import { render, staticRenderFns } from "./FriendsPage.vue?vue&type=template&id=3c0c85c6&scoped=true&"
import script from "./FriendsPage.vue?vue&type=script&lang=js&"
export * from "./FriendsPage.vue?vue&type=script&lang=js&"
import style0 from "./FriendsPage.vue?vue&type=style&index=0&id=3c0c85c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c85c6",
  null
  
)

export default component.exports